/* eslint-disable @typescript-eslint/no-redeclare,no-underscore-dangle,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars,no-var */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';
import { DESIGNER_SETTINGS } from '../../../../../app/constants/designer_settings';

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerMap', [
    '$rootScope',

    function ($rootScope) {
      function DesignerMap(designer) {
        this.designer = designer;
        this.scale = 1;
        this.panelScale = 0.18;

        this.element;

        this.width = Math.round(designer.width * this.panelScale);
        this.height = Math.round(designer.height * this.panelScale);

        this.minPackageWidth = this.width / this.panelScale;
        this.minPackageHeight = this.height / this.panelScale;

        this.x = 0;
        this.y = 0;

        this.initiated = false;

        this.init();
      }

      DesignerMap.prototype.init = function () {
        const _this = this;

        $rootScope.$on(DESIGNER_EVENTS.PACKAGE_RESIZE, function () {
          _this.setSize();
          _this.setPosition();
        });

        $rootScope.$on(DESIGNER_EVENTS.PACKAGE_SCROLL, function (event, scrollPosition) {
          if (_this.$overlayLeft) {
            _this.setViewPosition(scrollPosition);
          }
        });
      };

      DesignerMap.prototype.setElement = function (element) {
        this.element = element;
        this.$svg = element.find('#svg-map');
        this.$wrapper = element.find('.designer-map-wrapper');
        this.$viewport = element.find('.designer-map-viewport');
        this.$btnAlign = element.find('#button-align');

        this.$overlayTop = element.find('.designer-map-overlay-top');
        this.$overlayRight = element.find('.designer-map-overlay-right');
        this.$overlayBottom = element.find('.designer-map-overlay-bottom');
        this.$overlayLeft = element.find('.designer-map-overlay-left');

        const _this = this;

        this.$btnAlign.on('click', function () {
          _this.designer.package.align();
        });

        this.$wrapper.on('click', function (e) {
          _this.designer.moveScroll(
            (e.offsetY - (_this.height * _this.scale) / 2) / _this.scale / _this.panelScale,
            (e.offsetX - (_this.width * _this.scale) / 2) / _this.scale / _this.panelScale,
          );
        });

        this.initiated = true;

        this.initDraggable();
        this.setSize();
        this.setPosition();
        this.setViewPosition();
      };

      DesignerMap.prototype.initDraggable = function () {
        let startX;
        let startY;
        const _this = this;

        let startPosition;

        const getPosition = function (ui) {
          return {
            x: Math.round(ui.position.left),
            y: Math.round(ui.position.top),
          };
        };

        this.$viewport.draggable({
          start(event, ui) {
            startPosition = getPosition(ui);
            startPosition.x -= _this.x;
            startPosition.y -= _this.y;
          },
          stop(event, ui) {
            const position = getPosition(ui);
          },
          drag(event, ui) {
            const position = getPosition(ui);

            position.x -= startPosition.x;
            position.y -= startPosition.y;

            const top = position.y / _this.scale / _this.panelScale;
            const left = position.x / _this.scale / _this.panelScale;

            _this.designer.moveScroll(top, left);
          },
        });
      };

      DesignerMap.prototype.setSize = function () {
        if (!this.initiated) return;

        const designerSize = this.designer.getSize();
        const packageSize = this.designer.package.getSize();

        this.width = Math.round(designerSize.width * this.panelScale);
        this.height = Math.round(designerSize.height * this.panelScale);

        this.element.css('width', this.width + 32);
        this.element.css('height', this.height + 2);

        this.$wrapper.css('width', this.width);
        this.$wrapper.css('height', this.height);

        this.$svg.attr('width', this.width);
        this.$svg.attr('height', this.height);
        this.$svg.attr('viewBox', `0 0 ${this.width} ${this.height}`);

        const designerRatio = packageSize.width / packageSize.height;
        const mapRatio = this.width / this.height;
        this.scale = 1;

        if (designerRatio < mapRatio) {
          this.scale = this.height / (packageSize.height * this.panelScale);
        } else {
          this.scale = this.width / (packageSize.width * this.panelScale);
        }

        this.$viewport.attr('width', Math.round(this.width * this.scale));
        this.$viewport.attr('height', Math.round(this.height * this.scale));

        this.setViewPosition();
      };

      DesignerMap.prototype.setViewPosition = function (scrollPosition) {
        var scrollPosition = scrollPosition || this.designer.getScrollPosition();
        this.x = scrollPosition.left * this.scale * this.panelScale;
        this.y = scrollPosition.top * this.scale * this.panelScale;

        const overlayLeft = {
          x: 0,
          y: 0,
          width: this.x - 1 < 0 ? 0 : this.x - 1,
          height: this.height,
        };
        this.$overlayLeft.attr(overlayLeft);

        const overlayTop = {
          x: this.x - 1 < 0 ? 0 : this.x - 1,
          y: 0,
          width: this.width * this.scale + 1,
          height: this.y - 1 < 0 ? 0 : this.y - 1,
        };
        this.$overlayTop.attr(overlayTop);

        const overlayBottom = {
          x: this.x - 1 < 0 ? 0 : this.x - 1,
          y: this.y + this.height * this.scale,
          width: this.width * this.scale + 1,
          height: this.height - this.y - this.height * this.scale,
        };
        overlayBottom.height = overlayBottom.height < 0 ? 0 : overlayBottom.height;
        this.$overlayBottom.attr(overlayBottom);

        const overlayRight = {
          x: this.x + this.width * this.scale,
          y: 0,
          width: this.width - this.width * this.scale - this.x,
          height: this.height,
        };
        overlayRight.width = overlayRight.width < 0 ? 0 : overlayRight.width;
        this.$overlayRight.attr(overlayRight);

        this.$viewport.attr('transform', `translate(${Math.round(this.x) - 0.5}, ${Math.round(this.y) - 0.5})`);
      };

      DesignerMap.prototype.setPosition = function () {};

      return DesignerMap;
    },
  ]);
})(window.angular);
